import _ from "lodash";
import Vue from "vue";
import * as resaState from "../../store/types/resa-state";
import { ERequestType, fetchGetHelper, fetchPostHelper, fetchPutHelper } from "../../tools/fetch";
import { arrayOfTimestamp, compareTime, dateToTimeStamp, formatTimeH, nextTime, parseTime } from "../../tools/timeTool";

// GIT NOTE : git version d7f81b91 -> before remove subservices

/*************************************
 State
 **/
const state = {
	allServices: {},
	allServicesAndEvents: {},
	subServicesByDay: {},
	subServicesAndEventsByDay: {},
	mainServices: {},
	mainServicesWithoutEvents: {},
	lockedDays: {},
	unsubscribeServicesSnapShot: null,
	selectedSubService: "",
	selectedMainService: "",
	selectedDayServices: [],
	selectedDay: "",
	selectedServiceId: 0,
	isLoaded: false,
};

/*************************************
 Getters
 **/
const getters = {
	/**
	 * get all services of current resto
	 * @param {*} state
	 */
	getAllServices: function (state) {
		return state.allServices;
	},
	/**
	 * get all services of current resto
	 * @param {*} state
	 */
	getAllServicesAndEvents: function (state) {
		return state.allServicesAndEvents;
	},

	/**
	 * get all services of current resto
	 * @param {*} state
	 */
	getLockedDays: function (state) {
		return state.lockedDays;
	},

	/**
	 * get all service ids and name
	 * @param {*} state
	 */
	getAllServicesIdsAndName: function (state) {
		let ids = [];
		let rServices = [];
		Object.entries(state.allServices).forEach(([ms, valms]) => {
			let value = Object.assign({}, valms);
			value.ms = ms;
			rServices.push(value);
		});
		rServices.sort(function (a, b) {
			return a.order - b.order;
		});
		rServices.forEach((serv) => {
			ids.push(serv.ms);
		});
		return ids;
	},

	/**
	 * get all main services
	 * @param {*} state
	 */
	getMainServices: function (state) {
		// don't move this one
		return state.mainServices;
	},
	/**
	 * get all main services
	 * @param {*} state
	 */
	getMainServicesWithoutEvents: function (state) {
		// don't move this one
		return state.mainServicesWithoutEvents;
	},

	/**
	 * get all main services by day
	 * @param {*} day
	 * @param {*} openCheck check if it's open -> return nothing if it's close
	 * @param {*} grouped check if service is bundeled and return bundeled service
	 */
	getMainServicesForDay:
		(state) =>
		(dateObject, openCheck = false, grouped = false) => {
			// don't move this one for the moment
			let rServices = [];
			let selectTs = new Date(dateObject.date).getTime();
			Object.entries(state.allServices).forEach(([ms, valms]) => {
				let obj = valms;
				// check if event service is avaible
				if (
					obj[dateObject.labelDay] &&
					obj[dateObject.labelDay].type === "event" &&
					!obj[dateObject.labelDay].isClosed &&
					obj[dateObject.labelDay].tabTs &&
					obj[dateObject.labelDay].tabTs.length > 0
				) {
					let eventInThisDay = obj[dateObject.labelDay].tabTs.find((el) => el === selectTs);
					if (!eventInThisDay) return;
				}
				// for day in param get service infos
				obj["order"] = valms.order;
				if (openCheck) {
					if (obj[dateObject.labelDay] && !obj[dateObject.labelDay].isClosed) {
						obj[dateObject.labelDay]["name"] = ms;
						obj[dateObject.labelDay]["order"] = valms.order;
						rServices.push(obj[dateObject.labelDay]);
					}
				} else if (obj[dateObject.labelDay] !== undefined) {
					obj[dateObject.labelDay]["name"] = ms;
					obj[dateObject.labelDay]["order"] = valms.order;
					rServices.push(obj[dateObject.labelDay]);
				}
			});
			// sort by field order
			rServices.sort(function (a, b) {
				return a.order - b.order;
			});
			if (grouped) {
				let groupedServices = {};
				rServices.forEach((service) => {
					if (!Object.keys(groupedServices).find((key) => key === service.name.substr(0, 3))) Vue.set(groupedServices, service.name.substr(0, 3), []);
					groupedServices[service.name.substr(0, 3)].push(service);
				});
				return groupedServices;
			} else {
				return rServices;
			}
		},

	/**
	 * get data of selected main service data
	 */
	getSelectedMainServiceData: function (state, getters, rootState, rootGetters) {
		// TODO: get correct data (MainService) can be duplicated on subService
		if (state.allServices[getters["getSelectedMainService"]] === undefined) return undefined;
		return state.allServices[getters["getSelectedMainService"]][rootGetters["calendar/getSelectedDay"].labelDay];
	},
	getMainServiceDataByServiceAndDay: (state) => (service, labelDay) => {
		// TODO: get correct data (MainService) can be duplicated on subService
		return state.allServices[service][labelDay];
	},

	/**
	 * get selected Main Service
	 */
	getSelectedMainService: function (state) {
		// TODO: get correct data
		return state.selectedMainService;
	},

	/**
	 * get next service opened
	 * @param {*} day current day id
	 */
	getNextMainServiceOpen: (state, getters, rootState, rootGetters) => (dateObject) => {
		let idFind = dateObject.weekday - 1;
		let date = new Date(dateObject.date);
		let loop = 0;
		let count = 0;
		// idFind += 1
		while (
			getters["getMainServicesForDay"]({
				date: date,
				labelDay: rootGetters["calendar/getLabelDay"](idFind),
			}) !== undefined &&
			getters["getMainServicesForDay"]({
				date: date,
				labelDay: rootGetters["calendar/getLabelDay"](idFind),
			}).length === 0
		) {
			date.setDate(date.getDate() + 1);
			idFind += 1;
			count += 1;
			if (idFind === 7) {
				idFind = 0;
				loop += 1;
			}
		}
		if (count === 0) count = 1;
		return { newIdDay: idFind, weekLoop: loop, jumpDays: count };
	},

	/**
	 * get subservicesForDay
	 * @param {*} labelDay day label of day
	 */
	getSubServicesForDay: (state) => (labelDay) => {
		return state.subServicesByDay[labelDay];
	},

	/**
	 * get all subservice by day
	 */
	getAllSubServicesByDay: (state) => {
		return state.subServicesByDay;
	},

	/**
	 * get subservicesForDay
	 * @param {*} labelDay day label of day
	 */
	getSubServicesAndEventsForDay: (state) => (labelDay) => {
		return state.subServicesAndEventsByDay[labelDay];
	},

	/**
	 * get all subservice by day
	 */
	getAllSubServicesAndEventsByDay: (state) => {
		return state.subServicesAndEventsByDay;
	},

	/**
	 * get selected subservice
	 */
	getSelectedSubService: function (state) {
		// TODO: get correct data
		return state.selectedSubService;
	},

	/**
	 * Get number of interval in service
	 * @param {*} msSelect main service selected
	 * @param {*} dSelect day selected
	 */
	getNumberOfIntervalService: (state, getters) => (msSelect, dSelect) => {
		if (dSelect !== "order") {
			let tabHInter = [];
			let step = getters["getServiceFormInit"][msSelect][dSelect]["form"].intervalResa;
			let inter = nextTime(getters["getServiceFormInit"][msSelect][dSelect]["form"].hMinTakeResa, step);
			let id = 1;
			if (
				getters["getServiceFormInit"][msSelect][dSelect]["form"].hMinTakeResa !== getters["getServiceFormInit"][msSelect][dSelect]["form"].opening
			) {
				tabHInter.push({
					hour: getters["getServiceFormInit"][msSelect][dSelect]["form"].hMinTakeResa,
					id: id,
				});
				id += 1;
			}
			if (getters["getServiceFormInit"][msSelect][dSelect]["form"].hMaxTakeResa) {
				while (compareTime(inter, getters["getServiceFormInit"][msSelect][dSelect]["form"].hMaxTakeResa) < 0) {
					tabHInter.push({
						hour: inter,
						id: id,
					});
					inter = nextTime(inter, step);
					id += 1;
				}
				if (
					getters["getServiceFormInit"][msSelect][dSelect]["form"].hMaxTakeResa !==
						getters["getServiceFormInit"][msSelect][dSelect]["form"].closing &&
					getters["getServiceFormInit"][msSelect][dSelect]["form"].hMaxTakeResa !== getters["getServiceFormInit"][msSelect][dSelect]["form"].opening
				) {
					tabHInter.push({
						hour: getters["getServiceFormInit"][msSelect][dSelect]["form"].hMaxTakeResa,
						id: id,
					});
				}
			}
			return tabHInter;
		}
	},
	/**
	 * Get number of interval in service
	 * @param {*} msSelect main service selected
	 * @param {*} dSelect day selected
	 */
	getNumberOfIntervalServiceDyna: (state, getters) => (dSelect, servciesDatas) => {
		if (dSelect !== "order") {
			let tabHInter = [];
			let step = servciesDatas.intervalResa;
			let inter = nextTime(servciesDatas.hMinTakeResa, step);
			let id = 1;

			const isHourInArray = (hour) => {
				return tabHInter.some((item) => item.hour === hour);
			};

			if (servciesDatas.hMinTakeResa !== servciesDatas.opening && !isHourInArray(servciesDatas.hMinTakeResa)) {
				tabHInter.push({
					hour: servciesDatas.hMinTakeResa,
					id: id,
				});
				id += 1;
			}
			if (servciesDatas.hMaxTakeResa) {
				while (compareTime(inter, servciesDatas.hMaxTakeResa) < 0) {
					if (!isHourInArray(inter)) {
						tabHInter.push({
							hour: inter,
							id: id,
						});
						id += 1;
					}
					inter = nextTime(inter, step);
				}
				if (
					servciesDatas.hMaxTakeResa !== servciesDatas.closing &&
					servciesDatas.hMaxTakeResa !== servciesDatas.opening &&
					!isHourInArray(servciesDatas.hMaxTakeResa)
				) {
					tabHInter.push({
						hour: servciesDatas.hMaxTakeResa,
						id: id,
					});
				}
			}
			return tabHInter;
		}
	},

	/**
	 * get Service Form Init return service object formated with default values
	 */
	getServiceFormInit: function (state, getters) {
		let formatedData = {};
		formatedData["daysSortedById"] = [];
		// for each mainServices
		Object.entries(getters["getAllServices"]).forEach(([ms, valms]) => {
			formatedData[ms] = {};
			// for each days
			Object.entries(valms).forEach(([d, vald]) => {
				if (d !== "order") {
					let mainCapacity = vald.capacityIntervalMain;
					if (!mainCapacity || mainCapacity === "") mainCapacity = 0;
					formatedData[ms][d] = {};
					formatedData[ms][d]["form"] = {
						opening: vald.opening,
						closing: vald.closing,
						capacity: vald.capacity,
						capacityIntervalMain: mainCapacity,
						capacityIntervalTab: vald.capacityIntervalTab,
						hMaxTakeResa: vald.hMaxTakeResa,
						hMinTakeResa: vald.hMinTakeResa,
						intervalResa: vald.intervalResa,
						limitSecuChrono: vald.limitSecuChrono,
						limitAnnulation: vald.limitAnnulation,
						nbServices: vald.nbServices,
						lenghtService: vald.lenghtService,
						nbMaxByResa: vald.nbMaxByResa,
						nbMinByResa: vald.nbMinByResa,
						nbMaxResa: vald.nbMaxResa,
						closeAuto: vald.closeAuto,
						closeAutoTime: vald.closeAutoTime,
						cashOn: vald.cashOn,
						cashType: vald.cashType,
						cashPrice: vald.cashPrice,
						cashCouv: vald.cashCouv,
						cashLimitHour: vald.cashLimitHour,
						isClosed: vald.isClosed,
						invisible: vald.invisible,
						formIsOpen: false,
					};
					formatedData[ms][d]["label"] = d;
					formatedData[ms][d]["idDay"] = vald.idDay;
					formatedData[ms][d]["duplicate"] = "";
					// sort days
					if (formatedData["daysSortedById"][vald.idDay - 1] === undefined) {
						formatedData["daysSortedById"][vald.idDay - 1] = d;
					}
					if (!formatedData[ms][d]["form"].limitAnnulation) {
						formatedData[ms][d]["form"].limitAnnulation = "00:00";
					}
					if (formatedData[ms][d]["form"].nbMaxResa === undefined) {
						formatedData[ms][d]["form"].nbMaxResa = 0;
					}
					if (formatedData[ms][d]["form"].closeAuto === undefined) {
						formatedData[ms][d]["form"].closeAuto = false;
					}
					if (formatedData[ms][d]["form"].cashOn === undefined) {
						formatedData[ms][d]["form"].cashOn = false;
					}
					if (!formatedData[ms][d]["form"].closeAutoTime) {
						formatedData[ms][d]["form"].closeAutoTime = "00:00";
					}
				}
			});
		});
		return formatedData;
	},

	/**
	 * get day closed by service closed
	 */
	getClosedDays:
		(state) =>
		(withoutEvent, ts = null) => {
			// let msClosed = []
			let daysClosed = [];
			// let count = 0
			let tabDayByServices = {};

			Object.entries(state.allServices).forEach(([ms, valms]) => {
				Object.entries(valms).forEach(([d, service]) => {
					if (d !== "order") {
						if (!tabDayByServices[d]) tabDayByServices[d] = [];
						if (withoutEvent) {
							if (ts && service.type === "event" && !service.invisible) {
								if (service.tabTs.find((el) => el === ts)) tabDayByServices[d].push(service);
							} else {
								tabDayByServices[d].push(service);
							}
							if (service.type === "normal") tabDayByServices[d].push(service);
						} else {
							if (ts && service.type === "event") {
								if (service.tabTs.find((el) => el === ts)) tabDayByServices[d].push(service);
							} else {
								tabDayByServices[d].push(service);
							}
						}
					}
				});
			});
			Object.entries(tabDayByServices).forEach(([d, services]) => {
				let countClose = 0;
				let idDay = 0;
				services.forEach((service) => {
					idDay = service.idDay;
					if (service.isClosed) countClose++;
				});
				if (countClose === services.length) daysClosed.push(idDay);
			});
			return daysClosed;
		},

	/**
	 * get day closed by service closed
	 */
	getInvisibleDays: function (state) {
		let msClosed = [];
		let daysClosed = [];
		let count = 0;
		// for each services closed get idDay
		Object.entries(state.allServices).forEach(([ms, valms]) => {
			count++;
			// for each days
			Object.entries(valms).forEach(([d, vald]) => {
				if (d !== "order" && (vald.invisible || vald.isClosed)) msClosed.push(vald.idDay);
			});
		});
		// for each day closed for all services get it and send it
		// foreach closed day id
		msClosed.forEach(function (dClose) {
			// find count of id
			let countDay = msClosed.filter(function (val) {
				return val === dClose;
			}).length;
			// Don't store double
			let found = daysClosed.find((elem) => {
				return elem === dClose;
			});
			if (countDay === count && found === undefined) daysClosed.push(dClose);
		});
		return daysClosed;
	},

	/**
	 * get day is closed boolean
	 * @param {*} day day checked
	 */
	getDaysIsClosed:
		(state, getters) =>
		(day, widthoutEvent, ts = null) => {
			let found = getters["getClosedDays"](widthoutEvent, ts).find(function (val) {
				return val === day;
			});
			return found;
		},

	/**
	 * get day is closed boolean
	 * @param {*} day day checked
	 */
	getDaysIsInvisible: (state, getters) => (day) => {
		let found = getters["getInvisibleDays"].find(function (val) {
			return val === day;
		});
		return found;
	},

	/**
	 * get if in Current Service
	 * @param {*} andPass ? check something
	 */
	// TODO: refactor this function with popup manage resa
	inCurrentService:
		(state, getters, rootState, rootGetters) =>
		(andPass = false) => {
			if (andPass && rootGetters["calendar/selectedDayIsToday"] === -1) return true;
			// compare select date
			if (rootGetters["calendar/selectedDayIsToday"] === 0) {
				// compare select service and hour
				let now = new Date();
				let currentHour = `${now.getHours().toString()}:${now.getMinutes().toString()}`;

				let todaySubServices = getters["getMainServicesForDay"](rootGetters["calendar/getSelectedDay"]);
				let todaySubService = todaySubServices.find((val) => {
					if (val.subName === getters["getSelectedSubService"]) return val;
				});
				let openning = todaySubService.opening;
				if (todaySubService.tabId && todaySubServices[todaySubService.tabId].subOpening)
					openning = todaySubServices[todaySubService.tabId].subOpening;
				let ending = todaySubService.closing;
				if (todaySubService.tabId && todaySubServices[todaySubService.tabId].subOpening) ending = todaySubServices[todaySubService.tabId].closing;
				if (compareTime(currentHour, ending) > 0 || (compareTime(currentHour, openning) >= 0 && compareTime(currentHour, ending) <= 0)) return true;
				else return false;
			} else {
				return false;
			}
		},

	/**
	 * get tables locked for selected service
	 */
	getCurrentLockedTables: function (state, getters, rootState, rootGetters) {
		if (
			state.allServices[getters["getSelectedMainService"]] === undefined ||
			state.allServices[getters["getSelectedMainService"]][rootGetters["calendar/getSelectedDay"].labelDay] === undefined ||
			state.allServices[getters["getSelectedMainService"]][rootGetters["calendar/getSelectedDay"].labelDay].lockedTablesIds === undefined
		)
			return [];
		let tableIds =
			state.allServices[getters["getSelectedMainService"]][rootGetters["calendar/getSelectedDay"].labelDay].lockedTablesIds[
				rootGetters["calendar/getCurrentTimestamp"]
			];
		if (tableIds === undefined || tableIds.length === 0) return [];
		else return tableIds;
	},

	/**
	 * get table is locked for select service
	 * @param {*} id id of table
	 */
	getThisTableIsLock: (state, getters, rootState, rootGetters) => (id) => {
		if (Object.entries(state.allServices).length === 0) return false;
		let tableIds = getters["getCurrentLockedTables"];
		if (tableIds.length === 0) return false;
		else {
			let found = Object.entries(tableIds).find(([t, tId]) => {
				return tId === id;
			});
			if (found === undefined) return false;
			else return true;
		}
	},

	/**
	 * get service lock state
	 * @param {*} ms service id
	 */
	getServiceLockState: (state, getters, rootState, rootGetters) => (ms, selectDay) => {
		if (ms !== "" && selectDay) {
			// let serviceChecked = getters['getAllServices'][ms][selectDay.labelDay]
			let timeStamp = dateToTimeStamp(selectDay.day, selectDay.month - 1, selectDay.year);
			// check if is locked
			if (getters["getLockedDays"].length > 0) {
				let found = getters["getLockedDays"].find((val) => {
					return val.ts.toString() === timeStamp.toString() && val.service === ms;
				});
				if (found !== undefined) {
					return true;
				}
			}
		}
		return false;
	},

	/**
	 * get state of current selected Service for selected day
	 */
	getCurrentServiceLockState: (state, getters, rootState, rootGetters) => {
		let selectDay = rootGetters["calendar/getSelectedDay"];
		return getters["getServiceLockState"](state.selectedMainService, selectDay);
	},

	/**
	 * get Service datas is loaded
	 */
	getServicesIsLoaded: function (state) {
		return state.isLoaded;
	},

	/**
	 * get default service value
	 */
	getDefaultServiceValue: (state) => (id, idDay) => {
		return {
			idDay: idDay,
			id: id,
			isClosed: true,
			opening: "12:00",
			closing: "14:00",
			capacity: 50,
			capacityIntervalMain: 0,
			capacityIntervalTab: [],
			hMaxTakeResa: "14:00",
			hMinTakeResa: "12:00",
			intervalResa: "00:30",
			limitSecuChrono: "00:30",
			limitAnnulation: "00:00",
			nbServices: 1,
			lenghtService: "01:30",
			nbMaxByResa: 12,
			nbMinByResa: 1,
			nbMaxResa: 0,
			invisible: false,
			lockedDay: [],
		};
	},
};

/*************************************
 Mutations
 **/
const mutations = {
	/**
	 * set main services datas
	 * @param {*} state
	 * @param {*} dbData
	 */
	setMainServices(state, dbData) {
		state.mainServices = dbData;
	},

	/**
	 * set main services datas
	 * @param {*} state
	 * @param {*} dbData
	 */
	setMainServicesWithoutEvents(state, dbData) {
		state.mainServicesWithoutEvents = dbData;
	},

	/**
	 * set all services datas
	 * @param {*} state
	 * @param {*} dbData
	 */
	setAllServices(state, dbData) {
		state.allServices = dbData;
	},

	/**
	 * set all services datas
	 * @param {*} state
	 * @param {*} dbData
	 */
	setLockedServices(state, dbData) {
		state.lockedDays = dbData;
	},

	/**
	 * set sub services by day
	 * @param {*} state
	 * @param {*} dbData
	 */
	setSubServicesByDay(state, dbData) {
		state.subServicesByDay = dbData;
	},

	/**
	 * set selected service
	 * @param {*} state
	 * @param {*} val
	 */
	setSelectedService(state, val) {
		// TODO: set main service and subservcie
		state.selectedSubService = val.subs;
		state.selectedMainService = val.ms;
	},

	/**
	 * set selected services for day
	 * @param {*} state
	 * @param {*} arry
	 */
	setSelectedDayServices(state, arry) {
		state.selectedDayServices = arry;
	},

	/**
	 * set loaded store state
	 * @param {*} state
	 * @param {*} val
	 */
	setLoadedState(state, val) {
		state.isLoaded = val;
	},

	/**
	 * reset store
	 * @param {*} state
	 */
	resetStore(state) {
		state.allServices = {};
		state.subServicesByDay = {};
		state.selectedSubService = "";
		state.selectedMainService = "";
		state.selectedDayServices = [];
		state.selectedDay = "";
		state.selectedServiceId = 0;
		state.isLoaded = false;
		state.mainServices = {};
		state.unsubscribeServicesSnapShot = null;
	},
};

/*************************************
 Action
 **/
const actions = {
	/**
	 * Clean store
	 * @param {*} store params
	 */
	cleanStore: function ({ state, rootState, commit, dispatch }) {
		commit("resetStore");
	},

	/**
	 * Create, Remove or Update service
	 */

	/**
	 * Get current capacity of current selected service - async function for get nbcouvert -> dirty function but necessary
	 * TODO: move in reservations store
	 * @param {*} param0
	 * @param {*} payload:Object {
	 *  selectDay
	 *  tabHour
	 * }
	 */
	async getCurrentCapacity({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		let timeStamp = dateToTimeStamp(payload.selectDay.day, payload.selectDay.month - 1, payload.selectDay.year);
		let newTabHour = {};
		let orderTab = {};
		try {
			let uid = rootGetters["newUsers/getUidPublic"];
			await Promise.all(
				_.map(payload.tabHour, async (ms) => {
					await fetchGetHelper(ERequestType.ROOMS.GET_CAPCITY, `restoid=${uid}&ts=${timeStamp}&service=${ms.labelSub}`).then(async (count) => {
						// let roomCapacity = count.data
						// get selected services datas
						let serviceChecked = getters["getAllServices"][ms.labelSub][payload.selectDay.labelDay];

						let capacity = serviceChecked.capacity;
						// if (roomCapacity < capacity) capacity = roomCapacity

						await fetchGetHelper(ERequestType.RESAS.GET_BY_TS_SERVICE, `restoid=${uid}&ts=${timeStamp}&service=${ms.labelSub}`)
							.then((resas) => {
								let complet = false;
								// get order for services
								let order = getters["getMainServices"].find((el) => el.name === ms.labelSub).order;
								Vue.set(orderTab, ms.labelSub.toString(), order);
								// we have some resa
								let countCouv = payload.nbCouv;
								if (resas.data.length > 0) {
									// get nb resas
									let nbResas = 0;
									resas.data.forEach((resa) => {
										if (resa.state !== resaState.CANCELLED && resa.state !== resaState.NO_SHOW) {
											nbResas++;
										}
									});
									// check nbmax resa autorized
									if (serviceChecked.nbMaxResa !== undefined && serviceChecked.nbMaxResa !== 0 && nbResas >= serviceChecked.nbMaxResa) complet = true;
									// service is locked and not show at this time
									if (getters["getAllServices"][ms.labelSub] === undefined) complet = true;
									// check if is complet
									else {
										// count couv for all resa at this ts and service
										resas.data.forEach((resa) => {
											if (resa.state !== resaState.CANCELLED && resa.state !== resaState.NO_SHOW) countCouv += resa.nbCouvert;
										});
									}
								}
								// if count > capacity service is complet
								if (countCouv > capacity) complet = true;

								// if not complet push hour to new tab
								if (!complet) Vue.set(newTabHour, ms.labelSub.toString(), ms);
							})
							.catch((err) => {
								console.error(err);
							});
					});
				}),
			);
			// ordering new tab with hours entry
			let baseHoursSort = Object.entries(newTabHour);
			baseHoursSort.sort(function (a, b) {
				return parseInt(a[1].tab[0].hour.split(":")[0]) - parseInt(b[1].tab[0].hour.split(":")[0]);
			});
			// recreate object ordered
			let tmpObjSorted = {};
			baseHoursSort.forEach(function (item) {
				tmpObjSorted[item[0]] = item[1];
			});

			// ordering new tab with sortable tab
			let sortable = Object.entries(tmpObjSorted);
			sortable.sort(function (a, b) {
				if (parseInt(orderTab[a[0]]) !== parseInt(orderTab[b[0]])) {
					return orderTab[a[0]] - orderTab[b[0]];
				}
			});
			// recreate object ordered
			let objSorted = {};
			sortable.forEach(function (item) {
				objSorted[item[0]] = item[1];
			});
			// return datas ordered
			return objSorted;
		} catch (err) {
			console.error("getCurrentCapacity - Error getting documents: ", err, "NEED TO RELOAD");
		}
		return newTabHour;
	},

	/**
	 * Create Main service
	 * @param {*} param0
	 * @param {*} payload:Object {
	 *  name
	 *  order
	 * }
	 */
	createMainService: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		// check if service all ready exist
		let ms = getters["getMainServices"];
		let found = false;
		if (Object.keys(ms).length > 0) {
			found = ms.find(function (val) {
				return val.id.toLowerCase() === payload.name.toLowerCase();
			});
		}
		let userDatas = rootGetters["newUsers/getUser"];
		let uid = rootGetters["newUsers/getUidPublic"];

		return new Promise((resolve, reject) => {
			// if already reject
			if (found) {
				reject(new Error("Le service exist déjà"));
			} else {
				// else create service
				let newServices = {
					restoid: uid,
					name: payload.name,
					id: `${uid}_${payload.name}`,
					order: payload.order,
					services: {},
				};
				// for all weekdays create a default service
				let weekDays = rootGetters["calendar/getWeekdays"];
				weekDays.forEach(function (day) {
					let d = {
						[day.label]: {
							idDay: day.number,
							id: `${[day.label_3].toString()}1`,
							isClosed: true,
							opening: "12:00",
							closing: "14:00",
							capacity: 50,
							capacityIntervalMain: 0,
							capacityIntervalTab: [],
							hMaxTakeResa: "14:00",
							hMinTakeResa: "12:00",
							intervalResa: "00:30",
							limitSecuChrono: "00:30",
							limitAnnulation: "00:00",
							nbServices: 1,
							lenghtService: "01:30",
							nbMaxByResa: 12,
							nbMinByResa: 1,
							nbMaxResa: 0,
							invisible: false,
							lockedDay: [],
						},
					};
					Object.assign(newServices["services"], d);
				});

				// send datas to db
				fetchPostHelper(ERequestType.SERVICES.CREATE, newServices, userDatas.token)
					.then((res) => {
						dispatch("loadServicesStore");
						resolve(payload.name);
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			}
		});
	},

	/**
	 * remove main services
	 * @param {*} payload:Object {
	 *  - name: string,
	 *  - id: string
	 * }
	 */
	async removeMainService({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		let userDatas = rootGetters["newUsers/getUser"];
		let uid = rootGetters["newUsers/getUidPublic"];

		let deleteServices = {
			restoid: uid,
			name: payload.name,
			id: `${uid}_${payload.name}`,
		};
		// delete on db
		return new Promise(async (resolve, reject) => {
			await fetchPostHelper(ERequestType.SERVICES.DELETE, deleteServices, userDatas.token)
				.then(async (res) => {
					dispatch("loadServicesStore");
					resolve();
				})
				.catch((err) => {
					console.error(err);
					reject(err);
				});
		});
	},

	/**
	 * create Cash Day datas
	 * @param payload:Object {
	 *  - days: [String] array of timestamp
	 *  - service: String
	 *  - content: datas
	 * }
	 **/
	async createLockedServices({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		// Promise
		return new Promise(async (resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];
			// for tsIds create bdd entries
			for (const tsId of payload.days) {
				// create new cashday
				let newLockedDay = {
					restoid: uid,
					ts: parseInt(tsId),
					service: payload.service,
				};
				// send to db
				await fetchPostHelper(ERequestType.SERVICES.ADD_LOCKED_DAYS, newLockedDay, userDatas.token)
					.then((res) => {
						resolve();
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			}
			// update local datas
			dispatch("loadlockedDays");
			resolve();
		});
	},

	/**
	 * delete days datas Cash Day
	 * @param payload:Object {
	 *  - tIds: [String] array of timestamp
	 *  - service: String
	 * }
	 **/
	async deleteLockedDays({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		// return new promise
		// delete in data base.then(resolve())
		let userDatas = rootGetters["newUsers/getUser"];
		let uid = rootGetters["newUsers/getUidPublic"];

		return new Promise(async (resolve, reject) => {
			// delete
			for (let i = 0; i < payload.tIds.length; i++) {
				// delete cashday object infos
				let deleteLockedService = {
					restoid: uid,
					ts: parseInt(payload.tIds[i]),
					service: payload.service,
				};
				// delete on db
				await fetchPostHelper(ERequestType.SERVICES.DELETE_LOCKED_DAYS, deleteLockedService, userDatas.token)
					.then(async (res) => {
						resolve();
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			}
			// relaod datas
			dispatch("loadlockedDays");
			resolve();
		});
	},

	/**
	 * updateSelectedService
	 * @param {*} param0
	 * @param {*} payload:Object {
	 *  - ms
	 *  - services tab
	 *  - subs
	 * }
	 */
	updateSelectedService: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		let userDatas = rootGetters["newUsers/getUser"];
		let uid = rootGetters["newUsers/getUidPublic"];

		let updateServices = {
			restoid: uid,
			name: payload.ms,
			id: `${uid}_${payload.ms}`,
			services: payload.services,
		};

		return new Promise((resolve, reject) => {
			fetchPutHelper(ERequestType.SERVICES.UPDATE, updateServices, userDatas.token)
				.then((res) => {
					resolve(res);
					dispatch("loadServicesStore");
				})
				.catch((err) => {
					console.error(err);
					reject(err);
				});
		});
	},

	/**
	 * update CurrentService LockedTables
	 * @param {*} param0
	 * @param {*} tables Array of locked tables
	 */
	updateCurrentServiceLockedTables: function ({ state, rootState, commit, dispatch, getters, rootGetters }, tables) {
		// TODO: revoir l'utilitée de cette fonction
		return new Promise((resolve, reject) => {
			// get current datas
			let currentService = getters["getSelectedMainService"];
			let currentDay = rootGetters["calendar/getSelectedDay"].labelDay;
			let currentTs = rootGetters["calendar/getCurrentTimestamp"];

			// get all service and update datas locked table
			let lockTableUpdate = getters["getAllServices"];
			if (!lockTableUpdate[currentService][currentDay]["lockedTablesIds"]) lockTableUpdate[currentService][currentDay]["lockedTablesIds"] = {};
			lockTableUpdate[currentService][currentDay]["lockedTablesIds"][currentTs] = tables;

			// get order for service
			let order = getters["getMainServices"].find((el) => el.name === currentService).order;
			let _id = getters["getMainServices"].find((el) => el.name === currentService)._id;

			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];

			let updateServices = {
				restoid: uid,
				name: currentService,
				id: _id,
				services: lockTableUpdate[currentService],
				order: order,
			};

			// update datas
			resolve(
				new Promise((resolve, reject) => {
					fetchPutHelper(ERequestType.SERVICES.UPDATE, updateServices, userDatas.token)
						.then((res) => {
							dispatch("loadServicesStore");
							resolve(res);
						})
						.catch((err) => {
							console.error(err);
							reject(err);
						});
				}),
			);
		});
	},

	/**
	 * update Main Service Order
	 * @param {*} param0
	 * @param {*} payload:Object {
	 *  - name
	 *  - order
	 * }
	 */
	updateMainServiceOrder: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		let userDatas = rootGetters["newUsers/getUser"];
		let uid = rootGetters["newUsers/getUidPublic"];

		let updateServices = {
			restoid: uid,
			name: payload.name,
			id: `${uid}_${payload.name}`,
			order: payload.order,
		};

		return new Promise((resolve, reject) => {
			fetchPutHelper(ERequestType.SERVICES.UPDATE, updateServices, userDatas.token)
				.then((res) => {
					resolve(res);
					dispatch("loadServicesStore");
				})
				.catch((err) => {
					console.error(err);
					reject(err);
				});
		});
	},

	loadlockedDays: function ({ state, rootState, commit, dispatch, getters, rootGetters }) {
		let uid = rootGetters["newUsers/getUidPublic"];
		return new Promise((resolve, reject) => {
			fetchGetHelper(ERequestType.SERVICES.LOCKED_DAYS, `restoid=${uid}`)
				.then((res) => {
					commit("setLockedServices", res.data);
					resolve();
				})
				.catch((err) => {
					console.error("Error on loading lockedDays", err);
					reject(err);
				});
		});
	},

	/**
	 * load all service for selected restoid
	 * @param {*} param0
	 */
	loadServicesStore: function ({ state, rootState, commit, dispatch, getters, rootGetters }) {
		// get all datas for db
		let userDatas = rootGetters["newUsers/getUser"];
		let uid = rootGetters["newUsers/getUidPublic"];
		return new Promise((resolve, reject) => {
			fetchGetHelper(ERequestType.SERVICES.ALL, `restoid=${uid}`)
				.then((res) => {
					// if no services found
					if (res.data.length === 0) {
						commit("setAllServices", {});
						commit("setSubServicesByDay", {});
						commit("setMainServices", {});
						commit("setSelectedDayServices", []);
						commit("setSelectedService", { ms: "", subs: "" });
						commit("setLoadedState", true);
						return;
					}
					let s = {};
					let ms = [];
					// format datas
					res.data.forEach(function (service) {
						let servicesToPush = service.services;
						Object.entries(servicesToPush).forEach((normalService) => {
							if (normalService[0] !== "order") {
								normalService[1].type = "normal";
								normalService[1].name = service.name;
								normalService[1].subName = service.name;
								normalService[1].subOpening = normalService[1].opening;
								normalService[1].subId = service.name.substring(0, 3);
							}
						});
						servicesToPush["order"] = service.order;
						s[service.name] = servicesToPush;
						ms.push({
							_id: service.id,
							id: service.name,
							title: service.name,
							name: service.name,
							index: service.order,
							order: service.order,
							type: "normal",
						});
					});

					// order main service data
					ms.sort(function (a, b) {
						return a.order - b.order;
					});

					let subS = [];
					let allSubS = [];
					// create subserivce by day
					ms.forEach((msVal) => {
						// for each main services
						Object.entries(s[msVal.id]).forEach(([day, servicesVal]) => {
							if (userDatas === null) {
								// if no user logged hide invisible service
								if (servicesVal && !servicesVal.isClosed && !servicesVal.invisible && day !== "order") {
									if (subS[day] === undefined) {
										subS[day] = [];
										allSubS[day] = [];
									}
									let datas = {};
									if (servicesVal.nbServices > 1) {
										for (let i = 1; i <= servicesVal.nbServices; i++) {
											datas = {};
											datas = Object.assign({}, servicesVal);
											let hStart = nextTime(servicesVal.opening, servicesVal.lenghtService, i - 1);
											let subName = `${msVal.id} ${formatTimeH(parseTime(hStart))}`;
											datas["subId"] = msVal.id.substr(0, 3) + i.toString();
											datas["tabId"] = subS[day].length;
											datas["subOpening"] = hStart;
											datas["subName"] = subName;
											datas["name"] = msVal.id;
											datas["type"] = "normal";
											subS[day].push(datas);
											allSubS[day].push(datas);
										}
									} else {
										datas = Object.assign({}, servicesVal);
										let hStart = servicesVal.opening;
										let subName = msVal.id;
										datas["subId"] = msVal.id.substr(0, 3);
										datas["tabId"] = subS[day].length;
										datas["subOpening"] = hStart;
										datas["subName"] = subName;
										datas["name"] = msVal.id;
										datas["type"] = "normal";
										subS[day].push(datas);
										allSubS[day].push(datas);
									}
								}
							} else {
								// if user is logged show invisible service
								if (servicesVal && !servicesVal.isClosed && day !== "order") {
									if (subS[day] === undefined) {
										subS[day] = [];
										allSubS[day] = [];
									}
									let datas = {};
									if (servicesVal.nbServices > 1) {
										for (let i = 1; i <= servicesVal.nbServices; i++) {
											datas = {};
											datas = Object.assign({}, servicesVal);
											let hStart = nextTime(servicesVal.opening, servicesVal.lenghtService, i - 1);
											let subName = `${msVal.id} ${formatTimeH(parseTime(hStart))}`;
											datas["subId"] = msVal.id.substr(0, 3) + i.toString();
											datas["tabId"] = subS[day].length;
											datas["subOpening"] = hStart;
											datas["subName"] = subName;
											datas["name"] = msVal.id;
											datas["type"] = "normal";
											subS[day].push(datas);
											allSubS[day].push(datas);
										}
									} else {
										datas = Object.assign({}, servicesVal);
										let hStart = servicesVal.opening;
										let subName = msVal.id;
										datas["subId"] = msVal.id.substr(0, 3);
										datas["tabId"] = subS[day].length;
										datas["subOpening"] = hStart;
										datas["subName"] = subName;
										datas["name"] = msVal.id;
										datas["type"] = "normal";
										subS[day].push(datas);
										allSubS[day].push(datas);
									}
								}
							}
						});
					});

					// add events to mains service and subservice
					let events = rootGetters["events/getAllEvents"];
					let msAndEvents = [...ms];
					let allS = Object.assign({}, s);
					let labelDays = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
					if (events && Object.entries(events).length > 0) {
						events.forEach((event) => {
							// main services
							msAndEvents.push({
								_id: event.id,
								id: event.name,
								title: event.name,
								name: event.name,
								type: "event",
							});
							// services
							allS[event.name] = [];
							// subs
							if (event.services && Object.entries(event.services)) {
								Object.entries(event.services).forEach(([day, servicesVal]) => {
									allS[event.name][day] = servicesVal;
									// init base datas
									let eventService = servicesVal;
									eventService.type = "event";
									eventService.name = event.name;
									eventService.subName = event.name;
									eventService.subOpening = servicesVal.opening;
									eventService.tabId = 0;
									eventService.isClosed = false;
									eventService.id = `${day.substring(0, 3)}1`;
									eventService.idDay = labelDays.findIndex((el) => el === day) + 1;
									eventService.subId = event.name.substring(0, 3);
									eventService.tabTs = [];
									// add tab of Ts
									if (event.dates && event.dates.length === 1) {
										let start = new Date(event.dates[0]).getTime();
										eventService.tabTs.push(start);
									} else if (event.dates && event.dates.length > 1) {
										eventService.tabTs = arrayOfTimestamp(event.dates[0], event.dates[1]);
									}
									// push datas
									if (!allSubS[day]) allSubS[day] = [];
									allSubS[day].push(servicesVal);
								});
							}
						});
					}

					commit("setAllServices", allS);
					commit("setSubServicesByDay", allSubS);
					commit("setMainServices", msAndEvents);
					commit("setMainServicesWithoutEvents", ms);
					dispatch("findFirstOpenServiceHours", {
						day: rootGetters["calendar/getSelectedDay"],
						keepCurrent: true,
						passed: false,
						checkLock: false,
					})
						.then((val) => {
							commit("setSelectedDayServices", getters["getMainServicesForDay"](rootGetters["calendar/getSelectedDay"]), true);
							if (
								state.selectedSubService === "" &&
								state.selectedMainService === "" &&
								Object.entries(val).length > 0 &&
								val[Object.keys(val)[0]].tab.length > 0
							) {
								commit("setSelectedService", {
									ms: val[Object.keys(val)[0]].labelMs,
									subs: val[Object.keys(val)[0]].tab[0].subs,
								});
							}
							commit("setLoadedState", true);
							resolve();
						})
						.catch((err) => {
							console.error(err);
							commit("setLoadedState", true);
						});

					commit("setLoadedState", true);
					resolve();
				})
				.catch((err) => {
					// set loaded state
					commit("setLoadedState", true);
					reject(err);
				});
		});
	},

	/**
	 * load all service for selected restoid
	 * @param {*} param0
	 */
	loadOnlyEventsById: function ({ state, rootState, commit, dispatch, getters, rootGetters }, eventid) {
		// get all datas for db
		let uid = rootGetters["newUsers/getUidPublic"];
		return new Promise((resolve, reject) => {
			fetchGetHelper(ERequestType.EVENTS.GET_BY_ID, `restoid=${uid}&eventid=${eventid}`)
				.then((res) => {
					let exit = false;
					if (res.data.length === 0) exit = true;
					// check dates validity
					if (!exit && res.data[0].dates) {
						let endDate = new Date(res.data[0].dates[1]);
						let now = new Date();
						if (now.getTime() > endDate.getTime()) exit = true;
					}

					// if no events found
					if (exit) {
						commit("setAllServices", {});
						commit("setSubServicesByDay", {});
						commit("setMainServices", {});
						commit("setSelectedDayServices", []);
						commit("setSelectedService", { ms: "", subs: "" });
						commit("setLoadedState", true);
						return;
					}

					// add events to mains service and subservice
					let s = {};
					let ms = [];
					let subS = [];
					let allSubS = [];
					let labelDays = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
					labelDays.forEach((day) => {
						subS[day] = [];
						allSubS[day] = [];
					});
					let events = res.data;
					let msAndEvents = [...ms];
					let allS = Object.assign({}, s);
					if (events && Object.entries(events).length > 0) {
						events.forEach((event) => {
							// main services
							msAndEvents.push({
								_id: event.id,
								id: event.name,
								title: event.name,
								name: event.name,
								type: "event",
							});
							// services
							allS[event.name] = [];
							// subs
							Object.entries(event.services).forEach(([day, servicesVal]) => {
								allS[event.name][day] = servicesVal;
								// init base datas
								let eventService = servicesVal;
								eventService.type = "event";
								eventService.name = event.name;
								eventService.subName = event.name;
								eventService.desc = event.desc;
								eventService.subOpening = servicesVal.opening;
								eventService.isClosed = false;
								eventService.id = labelDays.findIndex((el) => el === day) + 1;
								eventService.idDay = `${day.substring(0, 3)}1`;
								eventService.subId = event.name.substring(0, 3);
								eventService.tabTs = [];
								// add tab of Ts
								if (event.dates && event.dates.length === 1) {
									let start = new Date(event.dates[0]).getTime();
									eventService.tabTs.push(start);
								} else if (event.dates && event.dates.length > 1) {
									eventService.tabTs = arrayOfTimestamp(event.dates[0], event.dates[1]);
								}
								// push datas
								if (!allSubS[day]) allSubS[day] = [];
								allSubS[day].push(servicesVal);
							});
						});
					}

					commit("setAllServices", allS);
					commit("setSubServicesByDay", allSubS);
					commit("setMainServices", msAndEvents);
					commit("setMainServicesWithoutEvents", ms);

					dispatch("findFirstOpenServiceHours", {
						day: rootGetters["calendar/getSelectedDay"],
						keepCurrent: true,
						passed: false,
						checkLock: false,
					})
						.then((val) => {
							commit("setSelectedDayServices", getters["getMainServicesForDay"](rootGetters["calendar/getSelectedDay"]), true);
							if (
								state.selectedSubService === "" &&
								state.selectedMainService === "" &&
								Object.entries(val).length > 0 &&
								val[Object.keys(val)[0]].tab.length > 0
							) {
								commit("setSelectedService", {
									ms: val[Object.keys(val)[0]].labelMs,
									subs: val[Object.keys(val)[0]].tab[0].subs,
								});
							}
							commit("setLoadedState", true);
							resolve();
						})
						.catch((err) => {
							console.error(err);
							commit("setLoadedState", true);
						});

					commit("setLoadedState", true);
					resolve();
				})
				.catch((err) => {
					// set loaded state
					commit("setLoadedState", true);
					reject(err);
				});
		});
	},

	/**
	 * Find selected service by day
	 * @param {*} payload:Object {
	 *  date
	 *  keepService
	 *  init
	 *  previous
	 * }
	 */
	findSelectedServiceByDay: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			// get IdDay for date
			let day = payload.date;
			let ts = new Date(payload.date.date).getTime();
			let today = new Date();
			let isToday = payload.date.isToday;
			if (
				getters["getSelectedMainServiceData"] &&
				getters["getSelectedMainServiceData"].type === "event" &&
				getters["getSelectedMainServiceData"].tabTs &&
				getters["getSelectedMainServiceData"].tabTs.length > 0
			) {
				let startDate = getters["getSelectedMainServiceData"].tabTs.reduce((a, b) => Math.max(a, b), -Infinity);
				let endDate = getters["getSelectedMainServiceData"].tabTs.reduce((a, b) => Math.max(a, b), -Infinity);
				if (startDate > ts) resolve();
				if (ts > endDate) {
					dispatch("calendar/moveToPreviousDay", payload.keepService, {
						root: true,
					});
					resolve();
				}
			}
			if (Object.entries(state.allServices).length > 0 && getters["getClosedDays"](false, ts).length < 7) {
				// Get store opening hours for select day
				let openningHours = getters["getMainServicesForDay"](day, true);
				if (openningHours !== undefined && openningHours.length > 0) {
					// store services for current day
					commit("setSelectedDayServices", openningHours);

					// find main service
					let selectedOpenning = openningHours[0];
					if (payload.keepService) {
						let index = openningHours.findIndex((element) => {
							return !element.isClosed && getters["getSelectedSubService"] === element.subName;
						});
						if (index > -1) selectedOpenning = openningHours[index];
						else if (payload.previous) selectedOpenning = openningHours[openningHours.length - 1];
					} else if (payload.previous) selectedOpenning = openningHours[openningHours.length - 1];

					if (isToday && payload.init) {
						// find by iteration
						let currentTime = `${today.getHours()}:${today.getMinutes()}`;
						openningHours.forEach(function (data) {
							if (compareTime(data.hour, currentTime) < 0) {
								selectedOpenning = data;
							}
						});
					}
					commit("setSelectedService", {
						ms: selectedOpenning.name,
						subs: selectedOpenning.subName,
					});
					resolve();
					return selectedOpenning.service;
				} else {
					if (payload.previous) {
						dispatch("calendar/moveToPreviousDay", payload.keepService, {
							root: true,
						});
						resolve();
					} else {
						dispatch("calendar/moveToNextDay", payload.keepService, {
							root: true,
						});
						resolve();
					}
				}
			}
		});
	},

	/**
	 * Find first open service hour
	 * @param {*} payload:Object {
	 *  day
	 *  checkLock
	 *  passed
	 *  keepCurrent
	 * }
	 */
	findFirstOpenServiceHours: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			let hoursDispo = {};
			let day = payload.day;
			let today = new Date();
			let currentTime = `${today.getHours()}:${today.getMinutes()}`;
			let count = 0;
			if (Object.keys(getters["getAllSubServicesByDay"]).length > 0) {
				let msOpen = getters["getMainServicesForDay"](day, true);
				if (msOpen !== undefined && msOpen.length > 0) {
					msOpen.forEach((service) => {
						// visibility servicies check
						let invisible = false;
						if (service.invisible !== undefined) invisible = service.invisible;
						let checkVisibility = false;
						if (payload.checkVisibility !== undefined) checkVisibility = payload.checkVisibility;
						let serviceVisibility = invisible && checkVisibility;

						// Get hours
						let maxHTest = service.hMaxTakeResa;
						if (maxHTest !== null && !serviceVisibility) {
							if (payload.keepCurrent && service.nbServices > 1) maxHTest = nextTime(service.subOpening, service.lenghtService);
							if (!payload.passed && day.isToday && compareTime(maxHTest, currentTime) < 0) {
								console.log("NOTE : Service passed", day.day, service.name, service.hMaxTakeResa, currentTime, maxHTest);
							} else if (payload.checkLock && getters["getServiceLockState"](service.name, day)) {
								if (hoursDispo[service.name] === undefined) hoursDispo[service.name] = {};
								if (hoursDispo[service.name].tab === undefined) hoursDispo[service.name].tab = [];
								hoursDispo[service.name].labelSub = service.subName;
								hoursDispo[service.name].labelMs = service.name;
								hoursDispo[service.name].lock = true;
							} else {
								if (hoursDispo[service.name] === undefined) hoursDispo[service.name] = {};
								if (hoursDispo[service.name].tab === undefined) hoursDispo[service.name].tab = [];
								hoursDispo[service.name].labelSub = service.subName;
								hoursDispo[service.name].labelMs = service.name;

								if (service.nbServices < 2) {
									let hstart = service.hMinTakeResa;
									let hend = service.hMaxTakeResa;
									let step = service.intervalResa;

									// check if current time is between hstart and hend
									let current = hstart;
									if (!payload.passed) {
										while (day.isToday && compareTime(current, currentTime) <= 0 && compareTime(current, hend) < 0) {
											current = nextTime(current, step);
										}
									}

									// get all interval hours
									while (compareTime(current, hend) <= 0) {
										hoursDispo[service.name].tab.push({
											hour: current,
											ms: service.name,
											subs: service.subName,
											id: count,
										});
										current = nextTime(current, step);
										count++;
									}
									if (hoursDispo[service.name].tab.length === 0) {
										Vue.delete(hoursDispo, service.name);
									}
								} else {
									let hstart = service.subOpening;
									if (day.isToday) {
										// get current service for restau app
										let hTest = hstart;
										if (payload.keepCurrent) hTest = nextTime(hstart, service.lenghtService);
										if (compareTime(hTest, currentTime) >= 0) {
											hoursDispo[service.name].tab.push({
												hour: hstart,
												ms: service.name,
												subs: service.subName,
												id: count,
											});
											count++;
										}
									} else {
										hoursDispo[service.name].tab.push({
											hour: hstart,
											ms: service.name,
											subs: service.subName,
											id: count,
										});
										count++;
									}
								}
							}
						}
					});
				}
				if (Object.keys(hoursDispo).length === 0) {
					// move to next service rescursive call with promise
					dispatch("calendar/moveToNDayAfterCurrent", getters["getNextMainServiceOpen"](day).jumpDays, { root: true }).then((val) => {
						resolve(
							dispatch("findFirstOpenServiceHours", {
								day: val,
								keepCurrent: true,
								passed: false,
								checkLock: payload.checkLock,
								checkVisibility: payload.checkVisibility,
							}),
						);
					});
				} else {
					resolve(hoursDispo);
				}
			} else {
				resolve({});
			}
		});
	},

	/**
	 * Service nav functions move to next service
	 * @param {*} param0
	 */
	moveToNextService: function ({ state, rootState, commit, dispatch }) {
		// find current Index
		if (state.selectedDayServices !== undefined && state.selectedSubService !== "" && state.selectedMainService !== "") {
			let currentIndex = state.selectedDayServices.findIndex(function (val) {
				return val.subName === state.selectedSubService;
			});
			// check if isn't the last
			if (currentIndex < state.selectedDayServices.length - 1) {
				commit("setSelectedService", {
					ms: state.selectedDayServices[currentIndex + 1].name,
					subs: state.selectedDayServices[currentIndex + 1].subName,
				}); // next
			} else {
				// is the last one go to next day
				dispatch("calendar/moveToNextDay", false, { root: true });
			}
		}
	},

	/**
	 * Fonction de navigation vers le service précédent
	 * @param {*} param0 - Paramètres de la fonction
	 */
	moveToPreviousService: function ({ state, rootState, commit, dispatch, getters, rootGetters }) {
		// Vérifier si les services du jour sélectionné, le sous-service et le service principal sont définis
		if (state.selectedDayServices !== undefined && state.selectedSubService !== "" && state.selectedMainService !== "") {
			// Trouver l'index du service actuel dans la liste des services du jour
			let currentIndex = state.selectedDayServices.findIndex(function (val) {
				return val.subName === state.selectedSubService;
			});
			// Obtenir le nombre de services principaux ouverts pour la journée sélectionnée
			const nbServiceOpen = getters["getMainServicesForDay"](rootGetters["calendar/getSelectedDay"], true).length;
			// Vérifier si ce n'est pas le premier service et s'il y a plus d'un service ouvert
			if (currentIndex > 0 && nbServiceOpen > 1) {
				// Sélectionner le service précédent
				commit("setSelectedService", {
					ms: state.selectedDayServices[currentIndex - 1].name,
					subs: state.selectedDayServices[currentIndex - 1].subName,
				}); // previous
			} else {
				// Si c'est le premier service, passer à la journée précédente
				dispatch("calendar/moveToPreviousDay", false, { root: true });
			}
		}
	},
};

/*************************************
 Helpers
 **/

/*************************************
 Export module
 **/
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
